import { render, staticRenderFns } from "./fail-list.vue?vue&type=template&id=1111faaf&scoped=true&"
import script from "./fail-list.vue?vue&type=script&lang=js&"
export * from "./fail-list.vue?vue&type=script&lang=js&"
import style0 from "./fail-list.vue?vue&type=style&index=0&id=1111faaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1111faaf",
  null
  
)

export default component.exports